export default __webpack_public_path__ + "fc50fa7f67a9461dd1b3a675e9b5478f.ttf";